/**
 * Derives what the total row shows for the selected pack:
 * - `included`: no added cost — just the plan's included credits.
 * - `priced`: a paid pack, or a custom amount above $0 — a monthly cost plus
 *   the combined credits.
 */
export function buildAgentPacksTotalDisplay({
  packs,
  selectedPackId,
  includedCredits,
  customMonthlyCost,
  customCredits
}) {
  const selectedPack = packs.find(p => p.id === selectedPackId);
  if (selectedPack && selectedPack.type === 'paid') {
    return {
      type: 'priced',
      monthlyCost: selectedPack.pricePerMonth,
      credits: includedCredits + selectedPack.credits
    };
  }
  if (selectedPack && selectedPack.type === 'custom' && customMonthlyCost > 0) {
    return {
      type: 'priced',
      monthlyCost: customMonthlyCost,
      credits: includedCredits + customCredits
    };
  }
  return {
    type: 'included',
    credits: includedCredits
  };
}